<template>
  <gg-card v-bind="$attrs">
    <gg-card-text>
      <div style="display: flex; flex-wrap: nowrap; gap: 16px;">
        <div v-if="isWithIcon && !iconWithTitle" style="flex-basis: 30px">
          <slot name="icon">
            <v-icon :size="iconSize" :color="iconColor" :class="'mt-2 ' + iconClass" :style="iconStyle">{{ icon }}</v-icon>
          </slot>
        </div>
        <div :style="`flex-grow: 1; min-width: ${mainBlockMinWidth}`">
          <slot name="default">
            <div :class="titleClass" :style="titleStyle">
              <slot v-if="iconWithTitle" name="icon">
                <v-icon :size="iconSize" :color="iconColor" :class="'mb-1 ' + iconClass" :style="iconStyle">{{ icon }}</v-icon>
              </slot>
              {{ title }}
            </div>
            <div :class="textClass" :style="textStyle">
              <slot name="text">
                {{ text }}
              </slot>
            </div>
          </slot>
        </div>
        <div v-if="isWithAppend">
          <slot name="append"></slot>
        </div>
      </div>
    </gg-card-text>
  </gg-card>
</template>
<script>
export default {
  name: 'ThinCard',

  props: {
    iconWithTitle: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: ''
    },
    iconSize: {
      type: Number,
      default: 24,
    },
    iconColor: {
      type: String,
      default: 'primary',
    },
    iconClass: {
      type: String,
      default: '',
    },
    iconStyle: {
      type: String,
      default: '',
    },
    titleClass: {
      type: String,
      default: 'body-1',
    },
    titleStyle: {
      type: String,
      default: '',
    },
    textClass: {
      type: String,
      default: '',
    },
    textStyle: {
      type: String,
      default: '',
    },
    mainBlockMinWidth: {
      type: String,
      default: '120px',
    },
  },

  computed: {
    isWithIcon () {
      return !!(this.icon.length || this.$slots.icon)
    },
    isWithAppend () {
      return !!this.$slots.append
    },
  }
}
</script>

<style scoped>

</style>
